/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';
import {
  DDUKDOC_BRAND_NAME,
  normalizeLegacyBrandName,
  replaceBrandName,
} from 'shared/helpers/BrandNameHelper';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces "Chatwoot" in text with the installation name from global config
   * @param {string} text - The text to process
   * @returns {string} - Text with "Chatwoot" replaced by installation name
   */
  const replaceInstallationName = text => {
    if (!text) return text;

    const installationName =
      normalizeLegacyBrandName(globalConfig.value?.installationName) ||
      DDUKDOC_BRAND_NAME;
    return replaceBrandName(text, installationName);
  };

  return {
    replaceInstallationName,
  };
}
